import { useRef, useEffect } from 'react';
import { Rect, Circle, Line, Path } from 'fabric';


/**
 * useWhiteboardShapes
 *
 * - Réécoute les events à chaque changement de `activeShapeType`
 * - Un seul useEffect qui gère attach/detach proprement
 * - Compatible souris + touch via listeners natifs sur le DOM element
 */
export function useWhiteboardShapes(fabricCanvasRef, activeShapeType, getColor, getBrushSize, socket,
  discussionId, userId) {
  const drawing    = useRef(false);
  const origin     = useRef({ x: 0, y: 0 });
  const currentObj = useRef(null);

  useEffect(() => {
  const canvas = fabricCanvasRef.current;
  if (!canvas || !activeShapeType) return;

const getPointer = (opt) => {
  return canvas.getScenePoint(opt.e);
};

  canvas.isDrawingMode = false;
  canvas.selection = false;
canvas.skipTargetFind = true;

canvas.forEachObject(obj => {
  obj.selectable = false;
});

  

  const onMouseDown = (opt) => {
    drawing.current = true;

    const p = getPointer(opt);
    origin.current = p;

    const color = getColor();
    const strokeWidth = getBrushSize();

    const common = {
      stroke: color,
      strokeWidth,
      fill: 'transparent',
      selectable: true,
      evented: true,
      strokeUniform: true,
    };

    let obj = null;

    switch (activeShapeType) {
      case 'rect':
        obj = new Rect({
          left: p.x,
          top: p.y,
          width: 0,
          height: 0,
          ...common,
        });
        break;

      case 'circle':
        obj = new Circle({
          left: p.x,
          top: p.y,
          radius: 0,
          ...common,
        });
        break;

      case 'line':
      case 'arrow':
        obj = new Line(
          [p.x, p.y, p.x, p.y],
          {
            ...common,
            fill: color,
          }
        );
        break;

      default:
        break;
    }

    if (obj) {
      canvas.add(obj);
      currentObj.current = obj;
      canvas.renderAll();
    }
  };

  const onMouseMove = (opt) => {
    if (!drawing.current || !currentObj.current) return;

    const p = getPointer(opt);
    const o = origin.current;
    const obj = currentObj.current;

    switch (activeShapeType) {
      case 'rect':
        obj.set({
          left: Math.min(p.x, o.x),
          top: Math.min(p.y, o.y),
          width: Math.abs(p.x - o.x),
          height: Math.abs(p.y - o.y),
        });
        break;

      case 'circle': {
        const radius = Math.hypot(p.x - o.x, p.y - o.y) / 2;

        obj.set({
          radius,
        });

        break;
      }

      case 'line':
      case 'arrow':
        obj.set({
          x2: p.x,
          y2: p.y,
        });
        break;

      default:
        break;
    }

    obj.setCoords();
    canvas.renderAll();
  };

  const onMouseUp = (opt) => {
    if (!drawing.current) return;

    drawing.current = false;

    const p = getPointer(opt);
    const o = origin.current;
    const obj = currentObj.current;

    if (activeShapeType === 'arrow' && obj) {
      const head = buildArrowHead(
        o.x,
        o.y,
        p.x,
        p.y,
        obj.stroke,
        obj.strokeWidth
      );

      if (head) canvas.add(head);
    }
if (obj) {
  if (!obj.id) {
    obj.set("id", crypto.randomUUID());
  }

  socket.emit("object:added", {
    discussionId,
    userId,
    object: obj.toObject(['src', 'id']),
  });
}

canvas.skipTargetFind = false;
  canvas.selection = true;
canvas.forEachObject(obj => {
    obj.selectable = true;
  });

    currentObj.current = null;

    canvas.renderAll();
  };

  canvas.on('mouse:down', onMouseDown);
  canvas.on('mouse:move', onMouseMove);
  canvas.on('mouse:up', onMouseUp);

  return () => {
    canvas.off('mouse:down', onMouseDown);
    canvas.off('mouse:move', onMouseMove);
    canvas.off('mouse:up', onMouseUp);
canvas.skipTargetFind = false;

canvas.forEachObject(obj => {
  obj.selectable = true;
});

    drawing.current = false;
    currentObj.current = null;
  };
}, [fabricCanvasRef, activeShapeType, getColor, getBrushSize]);
}

function buildArrowHead(x1, y1, x2, y2, color, strokeWidth) {
  const angle = Math.atan2(y2 - y1, x2 - x1);
  const len   = Math.max(10, strokeWidth * 4);
  const a     = Math.PI / 7;
  return new Path(
    `M ${x2 - len * Math.cos(angle - a)} ${y2 - len * Math.sin(angle - a)}
     L ${x2} ${y2}
     L ${x2 - len * Math.cos(angle + a)} ${y2 - len * Math.sin(angle + a)}`,
    { stroke: color, strokeWidth, fill: 'transparent',
      selectable: true, evented: true, strokeUniform: true }
  );
}
